import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { validateLogin, setCurrentOrder, getCurrentOrders, getCurrentOrder } from '../../actions/auth';
import { setHistoryPanel } from '../../actions/panels';
import clock from '../../assets/images/clock-icon.svg';
import HistoryReorderItem from '../history/HistoryReorderItem';
import ReorderItemDetails from '../history/ReorderItemDetails';
import OrderStatus from '../history/OrderStatus';
import favorite from '../../assets/images/orders-icon.svg';

import LoadingSpinner from '../common/LoadingSpinner';
import Tabs from '../common/NavigationTabs';

class HistoryPage extends Component {

    constructor(props) {
        super(props);

        const [taggedOrdersBool, unTaggedOrdersBool] = this.updateOrderBools();

        this.state ={
            taggedOrders:   taggedOrdersBool,
            unTaggedOrders: unTaggedOrdersBool,
        }
        
        this.handleSelectOrder = this.handleSelectOrder.bind(this);
        this.viewCurrentStatus = this.viewCurrentStatus.bind(this);

    }

    componentDidMount() {

        const token = window.localStorage.getItem('c2o.token');
        if (token) {
            this.props.dispatch(validateLogin({ token }));
        }else{

            let orderKey = window.localStorage.getItem('currentOrderKey');
            if(orderKey){
                let showStatusPage = window.localStorage.getItem('showStatusPage');
                window.localStorage.removeItem('showStatusPage');
                this.props.dispatch(getCurrentOrder(orderKey, showStatusPage));
            }

        }
    }

    componentDidUpdate() {
        
        const [taggedOrdersBool, unTaggedOrdersBool] = this.updateOrderBools();

        // This code was originally in the constructor alone but once logging out the bools never got updated and so it would try to read from the orderHistory when it was empty
        // Now it is being called in both the constructor and componentDidUpdate
        if(taggedOrdersBool != this.state.taggedOrders || unTaggedOrdersBool != this.state.unTaggedOrders){
            this.setState({
                taggedOrders:   taggedOrdersBool,
                unTaggedOrders: unTaggedOrdersBool,
            });
        }

        if(this.props.logged_in && this.props.currentOrder.id == '0'){

            const token = window.localStorage.getItem('c2o.token');
            if (token) {
                this.props.dispatch(getCurrentOrders({ token }));
            }

        }

    }

    updateOrderBools(){
        let taggedOrdersBool = (this.props.orderHistory ?? false) && this.props.orderHistory.length > 0 && this.props.orderHistory.filter(function(order){
            return order.tagged == 1;
        }).length > 0;

        let unTaggedOrdersBool = (this.props.orderHistory ?? false) && this.props.orderHistory.length > 0 && this.props.orderHistory.filter(function(order){
            return order.tagged == 0;
        }).length > 0;

        return [taggedOrdersBool, unTaggedOrdersBool];
    }

    renderOrderHistoryTaggedOrders() {

        if (this.props.orderHistory && this.props.orderHistory.length > 0 && this.state.taggedOrders) {
            return (
                <div className="orders-wrapper">
                    <div className="section-header-wrapper">
                        <img src={favorite}  className="most-small-icons _2" />
                        <div className="medium-header">Your Usual Eats:</div>
                    </div>
                    { this.renderHistoryItems({tagged: 1}) }
                </div>
            );
        }

    }

    renderOrderHistoryPastOrders() {
        if (this.props.logged_in) {

            if (this.props.orderHistory && this.props.orderHistory.length > 0 && this.state.unTaggedOrders) {
                return (
                    <div className="orders-wrapper">
                        <div className="section-header-wrapper">
                            <img src={clock}  className="most-small-icons _2" />
                            <div className="medium-header">Past Orders:</div>
                        </div>
                        { this.renderHistoryItems({tagged: 0}) }
                    </div>
                );
            }
            else if(this.props.orderHistory && this.props.orderHistory.length > 0){
                //Do not show "Past Orders" or the no orders message
            }
            else {
                return (
                    <div className="no-orders">
                        <p className="login-signup-button-label">No orders have been made yet under this account.</p>
                    </div>
                );
            }
        }
    }

    renderCurrentOrders(){

        if (this.props.logged_in) {

            if (this.props.currentOrders && this.props.currentOrders.length > 0) {
                return (
                    <div className="orders-wrapper">
                        <div className="section-header-wrapper">
                            <img src={clock}  className="most-small-icons _2" />
                            <div className="medium-header">Current Orders:</div>
                        </div>
                        {this.props.currentOrders.map((theHistoryItem) => <HistoryReorderItem key={theHistoryItem.id} handleSelectOrder={this.handleSelectOrder} viewCurrentStatus={this.viewCurrentStatus} item={theHistoryItem} recentOrder={true} />)}
                    </div>
                );
            }

        }

    }

    renderCurrentGuestOrder(){

        if (this.props.currentOrders && this.props.currentOrders.length > 0) {
            return (
                <div className="orders-wrapper mt-20">
                    <div className="section-header-wrapper">
                        <img src={clock}  className="most-small-icons _2" />
                        <div className="medium-header">Recent Order:</div>
                    </div>
                    {this.props.currentOrders.map((theHistoryItem) => <HistoryReorderItem key={theHistoryItem.id} handleSelectOrder={this.handleSelectOrder} viewCurrentStatus={this.viewCurrentStatus} item={theHistoryItem} recentOrder={true} />)}
                </div>
            );
        }

    }


    renderHistoryItems({tagged}) {
        if (this.props.orderHistory && this.props.orderHistory.length > 0) {

            const filterTaggedOrders = function (theHistoryItem) {
                return (theHistoryItem.tagged == 1);
            };
            
            const unfilterTaggedOrders = function (theHistoryItem) {
                return (theHistoryItem.tagged == 0);
            };

            const filterToUse = (tagged == 1) ? filterTaggedOrders: unfilterTaggedOrders;

            let filteredOrders = this.props.orderHistory
                        .filter(filterToUse);
            
            return  filteredOrders.map((theHistoryItem) => <HistoryReorderItem key={theHistoryItem.id} handleSelectOrder={this.handleSelectOrder} item={theHistoryItem} recentOrder={false} />);
        }
        else {
            return (
                <div className="no-orders">
                    <p className="login-signup-button-label">No orders have been made yet under this account.</p>
                </div>
            );
        }
    }

    renderOrderHistory() {

        return (
            <div className="section orders">
                <h2 className="heading">Orders</h2>
                { this.renderCurrentOrders() }
                { this.renderOrderHistoryTaggedOrders() }
                { this.renderOrderHistoryPastOrders() }
            </div>
        );
    }

    handleSelectOrder(historyItem) {
        this.setState(() => ({ historyItem }));
        this.props.dispatch(setHistoryPanel('reorder_item'));
    }

    viewCurrentStatus(historyItem) {
        this.props.dispatch(setCurrentOrder(historyItem));
        this.props.dispatch(setHistoryPanel('current_status'));
    }

    renderReorderItem() {
        return (
            <ReorderItemDetails 
                history={this.props.history}
                orderItem={this.state.historyItem}
            />
        );
    }

    renderOrderStatus(){
        return(
            <OrderStatus />
        );

    }

    renderActivePanel() {
        switch(this.props.curPanel) {

            case 'reorder_item':
                return this.renderReorderItem();

            case 'current_status':
                return this.renderOrderStatus();

            default:
                if(this.props.logged_in){
                    return this.renderOrderHistory();
                }else{
                    return this.renderGuestOrders();
                }
                
        }
    }

    renderGuestOrders(){

        return (
            <div>
                {this.renderCurrentGuestOrder() }
                <div  className="horizontal-history-padding">
                    <p className="login-signup-button-label">Please Login or sign up to fully use this feature.</p>
                    <div>
                        <Link 
                            className="login-signup-button"
                            to={'/'+this.props.match.params.sitename+'/'+this.props.match.params.lid+'/account'} 
                        >
                            Login / Sign Up
                        </Link>
                    </div>                
                </div>
            </div>
        );

    }

    render() {
        if (this.props.loading) {
            return (
                <LoadingSpinner />
            );
        }
        else {
            return (
                <div className="body">
                    <div className="breakpointContainer">
                        {this.renderActivePanel()}
                    </div>
    
                    <Tabs 
                        sitename={this.props.match.params.sitename}
                        lid={this.props.match.params.lid}
                        section="orders"
                    />
                </div>
            );
        }
    }
}


const mapStateToProps = (state) => {

    return {
        curPanel: state.panels.history,
        orderHistory: state.auth.user.orderHistory,
        currentOrders: state.auth.user.currentOrders,
        currentOrder: state.auth.currentOrder,
        user: state.auth.user,
        logged_in: state.auth.logged_in,
        loading: state.receipt.loading,
    };
};

export default connect(mapStateToProps)(HistoryPage);
